import { createElement, FC, Fragment, useContext, useState } from 'react';

import SideBar, { SidebarIframe } from '../component/compound/SideBar';
import TransitionToKaizenIdModal from '../component/compound/TransitionToKaizenIdModal';
import { context as ConfigContext } from '../context/config';
import { context as StateContext } from '../context/state';
import { SideBarProps } from './Toolbar';

type Props = {
  isOpenedByIframe: boolean;
  sideBarProps: SideBarProps;
};

export const ToolBarForPC: FC<Props> = ({ isOpenedByIframe, sideBarProps }) => {
  const config = useContext(ConfigContext);
  const state = useContext(StateContext);
  // 新規プロジェクト作成時のRegion別処理を実行
  const [isModalOpen, setModal] = useState(false);

  const transitionToKaizenIdModalProps = {
    urlToId: config.ID_WEB_URL,
    open: isModalOpen,
    language: state.language,
    onRequestClose: () => setModal(false),
  };

  return !state.fatalError && state.authentication.fetching === 0 && state.authentication.signedInUser ? (
    isOpenedByIframe ? (
      <>
        <SidebarIframe {...sideBarProps} />
        <TransitionToKaizenIdModal {...transitionToKaizenIdModalProps} />
      </>
    ) : (
      <>
        <SideBar {...sideBarProps} />
        <TransitionToKaizenIdModal {...transitionToKaizenIdModalProps} />
      </>
    )
  ) : null;
};
